import { FC } from "react";
import { developmentHistoryServiceFactory } from "../../../services/DevelopmentHistoryServiceImpl";
import { useTranslation } from "react-i18next";
import { IDevelopmentHistory, DevelopmentHistoryFiltersValues } from "../../../domain/models/DevelopmentHistory";
import { DevelopmentHistoryFiltersFields, developmentHistoryFiltersSchemaFactory } from "../../../validation-schemas/DevelopmentHistorySchemas";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import DevelopmentHistoryCard from "./DevelopmentHistoryCard";
import DevelopmentHistoryEditor from "./DevelopmentHistoryEditor";

const developmentHistoryService = developmentHistoryServiceFactory();
const DevelopmentHistoryPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<IDevelopmentHistory, DevelopmentHistoryFiltersValues>
            filtersFieldsMeta={DevelopmentHistoryFiltersFields}
            filtersSchema={developmentHistoryFiltersSchemaFactory(t)}
            service={developmentHistoryService}
            renderItem={(item, onEdit, onDelete) => (
                <DevelopmentHistoryCard
                    item={item}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            )}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <DevelopmentHistoryEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default DevelopmentHistoryPage;
